import axios, { AxiosResponse } from 'axios';
import { FullModule } from '../types';

export const getModuleList = async (): Promise<FullModule[]> => {
  return (await axios.get('/moduleList')).data;
};

export const getModuleById = async (moduleId: string): Promise<FullModule> => {
  return (
    await axios.get('/moduleMetadata', { params: { moduleId: moduleId } })
  ).data as FullModule;
};

export const getModuleVideo = async ({
  moduleId,
  videoId,
}: {
  moduleId: string;
  videoId: string;
}): Promise<AxiosResponse> => {
  return await axios.get('/moduleVideo', {
    params: { moduleId: moduleId, videoId: videoId, signedUrl: true },
  });
};

export const getModuleListeningLoop = async ({
  moduleId,
}: {
  moduleId: string;
}): Promise<AxiosResponse> => {
  return await axios.get('/moduleVideo', {
    params: { moduleId: moduleId, videoId: 'listening_loop', signedUrl: true },
  });
};
